import { createStore } from 'redux';

import { rootMiddleware } from '~/store/middlewares';
import { rootReducer } from '~/store/reducers';

export const store = createStore(rootReducer, undefined, rootMiddleware);
